import { Page, Navbar, Link, BlockTitle, List, ListItem } from "konsta/react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { appSlice, runLightColorShow } from "../../app/appSlice";
import { colors, colorShows, getColorForCode } from "../../app/colors";
import CheckIcon from "../icons/check-icon";
import PlusColorChip from "../icons/plus-color-chip";

function ColorList(props) {
  const dispatch = useAppDispatch();
  const editingLightColor = props.editingLightColor || "";
  const allLightColors = [
    "poolLights",
    "spaLights",
    "waterfallLights",
    "bubblerLights",
  ];
  const lightColor = useAppSelector(
    (state) => state.app[editingLightColor + "Color"]
  );
  const lightColorShow = useAppSelector(
    (state) => state.app[editingLightColor + "ColorShow"]
  );
  const allLightColorShows = useAppSelector((state) =>
    allLightColors.map((color) => ({
      color: color,
      show: state.app[color + "ColorShow"],
    }))
  );
  const lightColorObj = getColorForCode(lightColor);

  return (
    <Page>
      <Navbar
        colors={{ bgIos: "bg-blue-trim", textIos: "text-white" }}
        translucent={false}
        title={editingLightColor
          .split(/(?=[A-Z])/)
          .map((key) => key.charAt(0).toUpperCase() + key.slice(1))
          .join(" ")}
        left={
          <Link
            colors={{ navbarTextIos: "text-white" }}
            navbar
            onClick={() => dispatch(appSlice.actions.setEditingLightColor(""))}
          >
            Close
          </Link>
        }
      />
      <div>
        <List strong>
          <ListItem
            link
            chevron={true}
            onClick={() => {
              dispatch(
                appSlice.actions.setEditingCustomLightColor(editingLightColor)
              );
            }}
            media={
              lightColorObj.name === "Custom Color" && !lightColorShow ? (
                lightColorObj.icon
              ) : (
                <PlusColorChip className="w-10" />
              )
            }
            title="Custom Color"
            after={
              lightColorObj.name === "Custom Color" && !lightColorShow ? (
                <CheckIcon className="w-3.5" />
              ) : null
            }
          />
        </List>
        <BlockTitle>PRESET COLORS</BlockTitle>
        <List strong>
          {colors.map((color) => {
            return (
              <ListItem
                key={color.name + color.color}
                link
                chevron={false}
                onClick={() => {
                  dispatch(
                    appSlice.actions[
                      "set" +
                        editingLightColor.charAt(0).toUpperCase() +
                        editingLightColor.slice(1) +
                        "ColorShow"
                    ]("")
                  );
                  dispatch(
                    appSlice.actions[
                      "set" +
                        editingLightColor.charAt(0).toUpperCase() +
                        editingLightColor.slice(1) +
                        "Color"
                    ](color.color)
                  );
                }}
                media={color.icon}
                title={color.name}
                after={
                  lightColor.toLowerCase() === color.color.toLowerCase() &&
                  !lightColorShow ? (
                    <CheckIcon className="w-3.5" />
                  ) : null
                }
              />
            );
          })}
        </List>
        <BlockTitle>PRESET COLOR SHOWS</BlockTitle>
        <List strong>
          {colorShows.map((show) => {
            return (
              <ListItem
                key={show.id}
                link
                chevron={false}
                onClick={() => {
                  if (lightColorShow.toLowerCase() === show.id.toLowerCase()) {
                    return;
                  }
                  const lightColors = allLightColorShows
                    .filter((currentShow) => currentShow.show === show.id)
                    .map((show) => show.color);
                  lightColors.push(editingLightColor);
                  lightColors.forEach((color) => {
                    dispatch(
                      appSlice.actions[
                        "set" +
                          color.charAt(0).toUpperCase() +
                          color.slice(1) +
                          "Color"
                      ]("#FFFFFE")
                    );
                    dispatch(
                      appSlice.actions[
                        "set" +
                          color.charAt(0).toUpperCase() +
                          color.slice(1) +
                          "ColorShow"
                      ]("")
                    );
                  });
                  setTimeout(() => {
                    lightColors.forEach((color) => {
                      dispatch(
                        appSlice.actions[
                          "set" +
                            color.charAt(0).toUpperCase() +
                            color.slice(1) +
                            "ColorShow"
                        ](show.id)
                      );
                      dispatch(runLightColorShow(color));
                    });
                  }, 1000);
                }}
                media={show.icon}
                title={show.name}
                after={
                  lightColorShow.toLowerCase() === show.id.toLowerCase() ? (
                    <CheckIcon className="w-3.5" />
                  ) : null
                }
              />
            );
          })}
        </List>
      </div>
    </Page>
  );
}

export default ColorList;
